import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
} from "@material-ui/core/";
import { TextContext } from "@pages/bereken-bijdrage";
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Label, Question } from "../../form-layout";

type EmailFormProps = {
  onSubmitEmail: any;
};

function EmailForm(props: EmailFormProps) {
  const { handleSubmit, register, errors, getValues } = useForm();
  const text = useContext(TextContext);
  function validEmail(email: string): boolean {
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(email);
  }

  const spacing = 1;

  return (
    <div>
      <form id="emailForm" onSubmit={handleSubmit(props.onSubmitEmail)}>
        <Question spacing={spacing}>
          <Label label="E-mail" />
          <TextField
            id="userEmail"
            margin="dense"
            color="primary"
            variant="outlined"
            name="userEmail"
            inputRef={register({
              required: true,
              validate: () => validEmail(getValues("userEmail")),
            })}
            type="text"
            // value="jonas@aeco.cloud"
            fullWidth={true}
            // error={errors?.userEmail ? true : false}
            // helperText={errors.userEmail && <span>{errorTexts[errors.userEmail.type]}</span>}
            // style={{
            //   width: "100%",
            // }}
          />
        </Question>
        <Question spacing={spacing}>
          <Label label={text.emailLastNameFieldLabel} />
          <TextField
            id="lastName"
            margin="dense"
            color="primary"
            variant="outlined"
            name="lastName"
            fullWidth={true}
            inputRef={register({
              required: true,
            })}
          />
        </Question>
        <Question spacing={spacing}>
          <Label label={text.emailFirstNameFieldLabel} />
          <TextField
            id="firstName"
            margin="dense"
            color="primary"
            variant="outlined"
            name="firstName"
            fullWidth={true}
            inputRef={register({
              required: true,
            })}
          />
        </Question>
        <Question spacing={spacing}>
          <Label label={text.emailPostalCode} />
          <TextField
            id="PostalCode"
            margin="dense"
            color="primary"
            variant="outlined"
            name="PostalCode"
            fullWidth={true}
            inputRef={register({
              required: false,
            })}
          />
        </Question>

        <FormControl style={{ marginBottom: "20px", marginTop: "20px" }}>
          <FormControlLabel
            style={{ height: "30px" }}
            control={
              <Checkbox
                style={{ height: "30px" }}
                inputRef={register({
                  required: true,
                })}
                name="acceptTerms"
                color="primary"
              />
            }
            label={
              <label>
                {text.emailModalConsentText}{" "}
                <a href={text.emailModalLinkToTerms} target={"_blank"} rel="noopener noreferrer">
                  {text.termsOfUse}
                </a>
              </label>
            }
          />
          {errors.acceptTerms ? (
            <FormHelperText id="my-helper-text" style={{ color: "red", marginLeft: "5px" }}>
              {text.mustAcceptTermsText}
            </FormHelperText>
          ) : (
            <></>
          )}
        </FormControl>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          fullWidth={true}
          style={{ marginTop: "0px" }}
        >
          {text.sendReport}
        </Button>
      </form>
    </div>
  );
}

export default EmailForm;
